import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { EnvUtils } from '@/utils/env.utils';

export const reactPlugin: ReactPlugin = new ReactPlugin();

export const appInsights: ApplicationInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.APPLICATION_INSIGHTS_CONNECTION_STRING,
    enableAutoRouteTracking: false,
    autoTrackPageVisitTime: false,
    disableCookiesUsage: true,
  }
});

if (!EnvUtils.nodeEnvIs('test')) {
  appInsights.loadAppInsights();
}

// disable logs for development mode
if (EnvUtils.isDevelopment()) {
  appInsights.addTelemetryInitializer(() => false);
}

export function setGlobalCookieConsent(consent: boolean): void {
  appInsights.getCookieMgr().setEnabled(consent);
}